
import { TeamUser } from "./UserListItem";
import UserListItem from "./UserListItem";

interface UsersListProps {
  users: TeamUser[];
  onEditUser: (user: TeamUser) => void;
  onDeleteUser?: (user: TeamUser) => void;
}

const UsersList = ({ users, onEditUser, onDeleteUser }: UsersListProps) => {
  return (
    <div className="border rounded-lg divide-y">
      {users.map(user => (
        <UserListItem 
          key={user.id} 
          user={user} 
          onEditUser={onEditUser}
          onDeleteUser={onDeleteUser}
        />
      ))}
    </div>
  );
};

export default UsersList;
